import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {MaterialModules} from '../../app.material';
import {CoreMondules} from '../../core/core.modules';
import { DeliveryRateFinderComponent } from './DeliveryRateFinder.component';
import { GoogleMapsModule } from '@angular/google-maps';


@NgModule({
    declarations:[
        DeliveryRateFinderComponent
    ],
    exports:[
        DeliveryRateFinderComponent
    ],
    imports:[
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModules,
        CoreMondules,
        GoogleMapsModule
    ],
    providers:[
    ]
})
export class DeliveryRateFinderModule {}